var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconShareArrow = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H16V16H0z",
    transform: "translate(-18 -9) translate(18 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.805 35.7L7.68 32.137a.563.563 0 0 0-.93.426v1.876C2.985 34.482 0 35.237 0 38.8a4.791 4.791 0 0 0 1.953 3.612.418.418 0 0 0 .658-.437c-1.063-3.4.5-4.3 4.139-4.353v2.061a.563.563 0 0 0 .93.426l4.125-3.563a.563.563 0 0 0 0-.846z",
    transform: "translate(-18 -9) translate(20 -20)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconShareArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-share-arrow.bff8e137.svg";
export { ForwardRef as ReactComponent };